import { Component } from "@angular/core";
import { NavController, ModalController, ViewController, LoadingController, AlertController, NavParams, Platform } from "ionic-angular";
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';

import { MemberPage } from '../member/member';
import { DataProvider } from '../../providers/data/data';
import { CardProvider } from '../../providers/data/data';
import { PageProvider } from '../../providers/data/data';
import { RestProvider } from '../../providers/rest/rest';

@Component({
  selector: "page-basic",
  templateUrl: "basic.html"
})
export class BasicPage {
  private loading;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    private data: DataProvider,
    private card: CardProvider,
    private rest: RestProvider,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private inAppBrowser: InAppBrowser,
    private platform: Platform,
  ) {}

  public ionViewDidEnter(): void {    
    document.getElementById('mainHeader').style.display = 'none';
    document.getElementById('backmenu').style.display = 'none';    
    document.getElementById('headLogo').style.display = 'none';
    document.getElementById('headTitle').style.display = 'none';    
    document.getElementById('headTitle').style.marginTop = '-10px';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'トップメニュー';
    // document.title = '';
  }

  showProcess(id: any) {
    if(id == 1) {
      this.data.paymentType = 'basic';
      this.navCtrl.push(MemberPage, { url: 'basic' });
    } else if(id == 2) {
      this.data.paymentType = 'member';
      this.navCtrl.push(MemberPage, { url: 'member' });
    } 
  }

  back() {
    //this.nav.popToRoot();
    this.viewCtrl.dismiss(null);
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    return await this.loading.present();
  }

  async stopLoading() {
    return await this.loading.dismiss();
  }

  showAlert(err) {
    let alert = this.alertCtrl.create({
      title: "エラー!",
      subTitle: err,
      buttons: ["OK"]
    });
    alert.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/basic/basic.ts